<div class="flex flex-col h-screen">

  <!-- Header -->
  <div class="px-6 pt-4 pb-2">
    <div class="flex justify-between items-center">
      <div>
        <h1 class="text-2xl font-bold text-gray-800">Receitas dos Clientes</h1>
        <p class="text-sm text-gray-500">Gerencie as receitas de seus clientes</p>
      </div>
      <div class="space-x-4">
        <button (click)="changeDashboard()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
          {{showDashboard ? 'Esconder Painel' : 'Mostrar Painel'}}
        </button>
        <button (click)="createCustomer()" class="bg-orange-500 hover:bg-orange-600 cursor-pointer text-white px-4 py-2 rounded">
          Nova Receita
        </button>
      </div>
    </div>
  </div>

  <!-- Filtros -->
  <div class="px-6 py-4 bg-white shadow shrink-0 z-10">
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4">

      <!-- Input de busca -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Nome</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchTerm"
          (input)="onSearchChange()"
          placeholder="Digite o nome do cliente..."
          class="w-full text-sm"
        />
      </div>


      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Cpf</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchCpf"
          (input)="onSearchCpfChange()"
          placeholder="Digite o cpf do cliente..."
          class="w-full text-sm"
        />
      </div>


      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Código</label>
        <input
          pInputText
          type="text"
          [(ngModel)]="searchId"
          (input)="onSearchIdChange()"
          placeholder="Digite o Código do cliente..."
          class="w-full text-sm"
        />
      </div>

      <!-- Dropdown de status -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Status</label>
        <p-dropdown
          [options]="statusOptions"
          [(ngModel)]="currentStatus"
          (onChange)="onStatusChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o status"
          class="w-full text-sm"
        ></p-dropdown>
      </div>

      <!-- Dropdown de período -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Período</label>
        <p-dropdown
          [options]="dateRangeOptions"
          [(ngModel)]="currentDateRange"
          (onChange)="onDateRangeChange()"
          optionLabel="label"
          optionValue="value"
          placeholder="Selecione o período"
          class="w-full text-sm"
        ></p-dropdown>
      </div>


      <!-- Dropdown de estado -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Estado</label>
        <p-dropdown
          [options]="states"
          [(ngModel)]="selectedState"
          (onChange)="onStateChange()"
          optionLabel="description"
          optionValue="acronym"
          placeholder="Selecione o estado"
          class="w-full text-sm"
        ></p-dropdown>
      </div>


      <!-- Dropdown de cidade -->
      <div class="flex flex-col">
        <label class="text-sm font-medium text-gray-700 mb-1">Cidade</label>
        <p-dropdown
          [options]="cities"
          [(ngModel)]="selectedCity"
          (onChange)="onCityChange()"
          optionLabel="description"
          optionValue="description"
          placeholder="Selecione a cidade"
          [filter]="true"
          [showClear]="true">
          class="w-full text-sm"
        ></p-dropdown>
      </div> 
    </div>
  </div>


  <div class="flex flex-col overflow-y-auto pb-10">
    <!-- Cards resumo -->
    <div [hidden]="!showDashboard" class="px-6 py-4 grid grid-cols-1 lg:grid-cols-6 gap-4">
      <!-- Coluna dos Charts (2 cards grandes) -->
      <div class="lg:col-span-4" [ngClass]="currentStatus === 'todos' ? 'grid grid-cols-2 gap-4' : 'grid grid-cols-1 gap-4'">
        
        <!-- A receber -->
        <p-card *ngIf="currentStatus === 'pendente' || currentStatus === 'todos'" header="A receber">
          <div class="h-full" style="height: 165px;">
            <div class="flex flex-col justify-center h-1/3">
              <div class="text-3xl font-bold text-gray-800">
                R$ {{ financialDashboard.totalValuePending| number:'1.2-2' }}
              </div>
            </div>
            <div class="flex justify-end items-end h-2/3">
              <div [ngClass]="currentStatus === 'todos' ? 'w-32 xl:w-64' : 'w-80 xl:w-150'">
                <p-chart
                  type="bar"
                  [data]="getTotalValuePendingChartData()"
                  [options]="barChartOptions">
                </p-chart>
              </div>
            </div>
          </div>
        </p-card>

        <!-- Total vendido -->
        <p-card *ngIf="currentStatus === 'todos'" header="Total vendido"> 
        
          <div class="h-full" style="height: 165px;">
            <div class="flex flex-col justify-center h-1/3">
              <div class="text-3xl font-bold text-gray-800">
                R$ {{ financialDashboard.totalValueSold | number:'1.2-2' }}
              </div>
            </div>
            <div class="flex justify-end items-end h-2/3">
              <div class="w-32 xl:w-64">
                <p-chart
                  type="bar"
                  [data]="getTotalValueSoldChartData()"
                  [options]="barChartOptions">
                </p-chart>
              </div>
            </div>
          </div>
        </p-card>

        <p-card *ngIf="currentStatus === 'quitado'" header="Total quitado"> 
        
          <div class="h-full" style="height: 165px;">
            <div class="flex flex-col justify-center h-1/3">
              <div class="text-3xl font-bold text-gray-800">
                R$ {{ financialDashboard.totalValuePaid| number:'1.2-2' }}
              </div>
            </div>
            <div class="flex justify-end items-end h-2/3">
              <div class="w-80 xl:w-150">
                <p-chart
                  type="bar"
                  [data]="getTotalValuePaidChartData()"
                  [options]="barChartOptions">
                </p-chart>
              </div>
            </div>
          </div>
        </p-card>

        <p-card *ngIf="currentStatus === 'cancelado'" header="Total cancelado"> 
        
          <div class="h-full" style="height: 165px;">
            <div class="flex flex-col justify-center h-1/3">
              <div class="text-3xl font-bold text-gray-800">
                R$ {{ financialDashboard.totalValueCanceled| number:'1.2-2' }}
              </div>
            </div>
            <div class="flex justify-end items-end h-2/3">
              <div class="w-80 xl:w-150">
                <p-chart
                  type="bar"
                  [data]="getTotalValueCanceledChartData()"
                  [options]="barChartOptions">
                </p-chart>
              </div>
            </div>
          </div>
        </p-card>
      </div>
      <!-- Grid 2x2 de Cards Pequenos -->
      <div class="lg:col-span-2 grid grid-cols-2 gap-4 gap-y-4">
        
        <!-- Receitas -->
        <p-card header="Receitas" class="h-full">
          <div class="flex flex-col justify-center h-full">
            <div class="text-3xl font-bold text-gray-800">
              {{ financialDashboard.totalRevenues| number }}
            </div>
          </div>
        </p-card>

        <!-- Clientes -->
        <p-card header="Clientes" class="h-full">
          <div class="flex flex-col justify-center">
            <div class="text-3xl font-bold text-gray-800">
              {{ financialDashboard.activeCustomers }}
            </div>
          </div>
        </p-card>

        <!-- Receitas Pendentes - só mostra quando currentStatus = 'todos' -->
        <p-card *ngIf="currentStatus === 'todos'" header="Pendentes" class="h-full">
          <div class="flex flex-col justify-center h-full">
            <div class="text-3xl font-bold text-yellow-600">
              {{ financialDashboard.pendingRevenues }}
            </div>
          </div>
        </p-card>

        <!-- Receitas Quitadas - só mostra quando currentStatus = 'todos' -->
        <p-card *ngIf="currentStatus === 'todos'" header="Quitadas" class="h-full">
          <div class="flex flex-col justify-center h-full">
            <div class="text-3xl font-bold text-green-600">
              {{ financialDashboard.paidRevenues }}
            </div>
          </div>
        </p-card>
      </div>
    </div>

  <!-- Tabela -->
    <div class="w-full flex-1 px-6 py-4 bg-gray-50">
        <div class="bg-white shadow rounded overflow-x-auto">
          <p-table 
            [value]="financials" 
            [paginator]="false"
            [loading]="loading"
            styleClass="p-datatable-sm"
            [rowHover]="true"
            [stripedRows]="true"
            stripedRowsClass="bg-orange-50"
            [showCurrentPageReport]="false"
            responsiveLayout="scroll"
            class="min-w-full text-sm">
            <ng-template pTemplate="header">
              <tr class="bg-gray-100">
                <th class="text-left px-4 py-2">Código</th>
                <th class="text-left px-4 py-2">Nome</th>
                <th class="text-left px-4 py-2">Total compras (R$)</th>
                <th class="text-left px-4 py-2">Valor devido (R$)</th>
                <th class="text-left px-4 py-2">Situação</th>
                <th class="text-left px-4 py-2">Receitas</th>
                <th class="text-left px-4 py-2">Ações</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-customer let-i="rowIndex">
              <tr [ngClass]="i % 2 === 0 ? 'bg-white' : 'bg-orange-50'">
                <td class="px-4 py-1 font-mono align-top">{{ customer.customerId }}</td>
                <td class="px-4 py-1 align-top">
                  <div class="font-semibold text-gray-900 leading-tight">{{ customer.customerName }}</div>
                  <div *ngIf="getCustomerAddress(customer)" class="text-xs text-gray-500 leading-tight mt-0.5">
                    {{ getCustomerAddress(customer) }}
                  </div>
                </td>
                <td class="px-4 py-1 align-top">R$ {{ customer.totalRevenue | number:'1.2-2' }}</td>
                <td class="px-4 py-1 align-top font-medium text-amber-800">R$ {{ (customer.amountDue ?? 0) | number:'1.2-2' }}</td>
                <td class="px-4 py-1 align-top">
                  <p-tag
                    [value]="customer.status"
                    [severity]="getStatusSeverity(customer.status)"
                    [rounded]="false">
                  </p-tag>
                </td>
                <td class="px-4 py-1 align-top">{{ customer.revenueCount }}</td>
                <td class="px-4 py-1 align-top">
                  <div class="flex space-x-2">
                    <p-button
                      pTooltip="Imprimir Histórico"
                      icon="pi pi-history"
                      text
                      severity="secondary"
                      (click)="printHistory(customer.customerId)">
                    </p-button>

                    <p-button
                      pTooltip="Ver Receitas"
                      icon="pi pi-arrow-circle-right"
                      text
                      severity="secondary"
                      (click)="goToRevenues(customer)">
                    </p-button>
                    
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="7" class="text-center py-8 text-gray-500">
                  Nenhum cliente encontrado
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
        
        <!-- Paginator -->
        <div class="flex justify-center py-4">
          <p-paginator
            [first]="first"
            [rows]="rows"
            [totalRecords]="totalRecords"
            (onPageChange)="onPageChange($event)"
            [showCurrentPageReport]="true"
            [showPageLinks]="true"
            [showFirstLastIcon]="true"
            styleClass="custom-paginator">
          </p-paginator>
        </div>
    </div>
  </div>

</div>
